export enum AccessRights {
    "edit" = "Edit",
    "readOnly" = "Read-Only",
    "notAvailable" = "N/A"
}